import { combineReducers } from 'redux';

import certDetailsReducer from './certdetails';
import certListReducer from './certlist';
import preLaunchReducer from './prelaunch';

const certsReducer = combineReducers({
  details: certDetailsReducer,
  list: certListReducer,
  prelaunch: preLaunchReducer,
});

export default certsReducer;

// BELOW CODE TO BE USED WHEN CERTIFICATION IS SEPARATED FROM HOST APP
// Require updated Node.js version for Redux toolkit to work

// const certsStore = configureStore({
//   reducer: certRootReducers,
//   // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk), // Redux Toolkit already includes redux-thunk in its default middleware setup
//   devTools: process.env.NODE_ENV !== 'production',
// });

// export default certsStore;
